import Logo from '../../assets/images/logo.png';
import './Logo.scss'

const Navbar = () => {
    return (
        <div className="logo">
            <img src={Logo} alt="Pnuema Life City Church Logo" />
            <p className="logo-text">Pneuma Life<br/> City Church</p>
        </div>
    );
};

export default Navbar
